import React from 'react';
import { RefreshCwIcon, WalletIcon } from 'lucide-react';
import { CurrencyField } from './CurrencyField';
import { PanelCard } from './PanelCard';
import { HousingPayment, HousingPaymentKey } from '../types/dscr';
import { arriveHousingPayment } from '../data/loan';
import { formatCurrency, totalHousingPayment } from '../utils/dscr';
interface HousingPaymentPanelProps {
  payment: HousingPayment;
  onChangeField: (key: HousingPaymentKey, value: number) => void;
  onRefresh: () => void;
  isRefreshing: boolean;
  isOverridden: boolean;
}
const FIELDS: {
  key: HousingPaymentKey;
  label: string;
}[] = [{
  key: 'principalAndInterest',
  label: 'Principal & interest'
}, {
  key: 'homeownersInsurance',
  label: 'Homeowners insurance'
}, {
  key: 'propertyTax',
  label: 'Property tax'
}, {
  key: 'mortgageInsurance',
  label: 'Mortgage insurance'
}, {
  key: 'other',
  label: 'Other (HOA, flood, etc.)'
}];
export function HousingPaymentPanel({
  payment,
  onChangeField,
  onRefresh,
  isRefreshing,
  isOverridden
}: HousingPaymentPanelProps) {
  const total = totalHousingPayment(payment);
  return <PanelCard title="Housing Payment" icon={<WalletIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="js4xf7wshyrn" />} action={<button type="button" onClick={onRefresh} disabled={isRefreshing} className="inline-flex items-center gap-1.5 rounded border border-[#0176d3] bg-white px-3 py-1.5 text-xs font-semibold text-[#0176d3] transition hover:bg-[#0176d3] hover:text-white disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-[#0176d3]/40" data-id="element-33" data-mp="xquzz32doqne">
          <RefreshCwIcon className={`h-3.5 w-3.5 ${isRefreshing ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-34" data-mp="eubvws6flsxp" />
          {isRefreshing ? 'Refreshing…' : 'Refresh from Arive'}
        </button>} className="h-full" data-id="element-31" data-mp="jswms0zsn09h">
      {isOverridden ? <p role="status" className="mb-4 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-800" data-id="element-35" data-mp="3ehbf7uld1kcm">
          Highlighted fields have been overridden for this what-if. Refreshing from Arive will
          restore the synced values.
        </p> : null}

      <div className="mb-5 space-y-3" data-id="element-36" data-mp="1r5p72yqhtzzw">
        {FIELDS.map(field => <CurrencyField key={field.key} id={`payment-${field.key}`} label={field.label} value={payment[field.key]} changed={payment[field.key] !== arriveHousingPayment[field.key]} onChange={value => onChangeField(field.key, value)} data-id="element-37" data-mp="1w4segpty4ib1" />)}
      </div>

      <div className="mt-auto flex items-baseline justify-between rounded border border-slate-200 bg-slate-50 px-4 py-3" data-id="element-38" data-mp="18eob8jko6kkk">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-39" data-mp="1dfvfi8nlt1mh">
          Total monthly housing payment
        </span>
        <span className="text-lg font-semibold tabular-nums text-slate-900" data-id="element-40" data-mp="2ot7nmvqec6eg">
          {formatCurrency(total)}
        </span>
      </div>
    </PanelCard>;
}